var EmotionHeader = require('./CC.EmotionHeader');
var Shop = require('./CC.EmotionHeader.Shop');
var Title = require('./CC.EmotionHeader.Title');
var Logo = require('./CC.EmotionHeader.Logo');
var Settings = require('./CC.EmotionHeader.Settings');
var Preview = require('./CC.EmotionHeader.Preview');
var Background = require('./CC.EmotionHeader.Background');

var $ = require('jquery');

var ns = diy.core.namespace('diy.editor.emotionHeader');

Object.assign(ns, {
    EmotionHeader: EmotionHeader,
    Shop: Shop,
    Title: Title,
    Logo: Logo,
    Settings: Settings,
    Background: Background,
    Preview: Preview
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/init.js
 ** module id = 870
 ** module chunks = 0
 **/